import { render, staticRenderFns } from "./PropostaEditDocumento.vue?vue&type=template&id=fb2887e6"
import script from "./PropostaEditDocumento.vue?vue&type=script&lang=js"
export * from "./PropostaEditDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports